// Localização: frontend/src/components/Prontuario/PacienteTimelineTab.jsx (Versão 1.0.0)
// Aba de Timeline do Prontuário

import React from 'react';
import TimelineView from './TimelineView';
import Title from '../Layout/Title';

/**
 * Componente de Aba de Timeline
 * @param {number} pacienteId - ID do paciente
 */
const PacienteTimelineTab = ({ pacienteId }) => {
    const handleEventClick = (event) => {
        // Callback quando um evento é clicado
        // Pode ser usado para navegar para detalhes, abrir modal, etc.
        console.log('Evento clicado na timeline:', event);
    };

    return (
        <div className="space-y-4">
            <Title text="Timeline do Prontuário" size="small" />
            <TimelineView 
                pacienteId={pacienteId}
                onEventClick={handleEventClick}
            />
        </div>
    );
};

export default PacienteTimelineTab;

